import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Homepage.module.css";
import IncomingCourses from "../../../components/incomingCourses/IncomingCourses";


import OtherCourses from "../../../components/otherCourses/OtherCourses";
import Benefits from "../../../components/benefits/Benefits";
import CalendarSubscription from "../../../components/calendarSubscription/CalendarSubscription";

import { GetCourses } from "../../../store/course-store/course-actions";
import Loading from "../../../components/loading/Loading";
import HomeFooter from "../../../components/homeFooter/HomeFooter";

const Homepage = () => {
  const dispatch = useDispatch();
  const courses = useSelector((state) => state.course.courses);

  useEffect(() => {
    if (courses !== null && courses !== undefined && courses.length === 0) {
      dispatch(GetCourses("jmiranda@aba.org.do", false));
    }
  });


  const capacitations = courses ? (courses.filter(
    (course) => course.courseTypeId === 1
  )) : null;
  const certifications = courses ? (courses.filter(
    (course) => course.courseTypeId === 2
  )) : null;
  const webinars = courses ? courses.filter(
    (course) => course.courseTypeId === 3
  ) : null;
  const asyncCourses = courses ? courses.filter(
    (course) => course.courseTypeId === 4
  ) : null;

  return (
    <>
      {courses ? courses.length <= 0 ? (
        <Loading />
      ) : (
        <div className={styles.homepage}>
          <IncomingCourses courses={capacitations} />
          <OtherCourses asyncCourses={asyncCourses} certifications={certifications} webinars={webinars}/>
          <Benefits />
          <CalendarSubscription />
          <HomeFooter />
        </div>
      ) : null}
    </>
  );
};

export default Homepage;
